import React, { useEffect, useState } from "react";
import Footer from "../../../Kryzen Alpha App/Components/Footer/footer";
import StepRoutes from "../../../Kryzen Alpha App/Routes/steps_routes";
import { useNavigate, useParams } from "react-router-dom";
import LoadingPage from "../../../Kryzen Alpha App/Components/layouts/loading";
import { Toast } from "../../../Kryzen Alpha App/CustomComponent/toast";
import performRequest from "../../../Kryzen Alpha App/api/request";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import { extractDate } from "../../Components/Functions/date.fun";
import { FcInspection, FcNeutralTrading } from "react-icons/fc";

const ViewLeadMaster = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  let { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/leadsMaster/getLeadMasterById/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
        } else {
          Toast("error", "Error while getting leads master !");
        }
        setLoading(false);
      })

      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">
                  <FcNeutralTrading className="fs-2 me-1" />
                  View Leads Master Details
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header">
              <h2 className="page-title">View Leads Master Details</h2>
            </div>

            <div className="card-body">
              <h2>Customer Information</h2>
              <hr></hr>
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Full Name:</label>
                  <div className="w-100 col">{data?.full_name || "N/A"}</div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Contact Number:
                  </label>
                  <div className="w-100 col">
                    {data?.mobile_number || "N/A"}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Alternate Number :
                  </label>
                  <div className="w-100 col">
                    {data?.alternate_number || "N/A"}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Email id :</label>
                  <div className="w-100 col">{data?.email_id || "N/A"}</div>
                </div>
              )}

              {data?.city && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">City :</label>
                  <div className="w-100 col">{data?.city || "N/A"}</div>
                </div>
              )}

              {data?.state && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">State :</label>
                  <div className="w-100 col">{data?.state || "N/A"}</div>
                </div>
              )}

              {data?.country && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Country :</label>
                  <div className="w-100 col">{data?.country || "N/A"}</div>
                </div>
              )}

              {data?.pincode && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Pincode :</label>
                  <div className="w-100 col">{data?.pincode || "N/A"}</div>
                </div>
              )}
              <hr></hr>
              <h2>Sourse Platform And Enquiry Details</h2>
              <hr></hr>

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Source platform :
                  </label>
                  <div className="w-100 col">
                    {data?.source_platform || "N/A"}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    First enquiry date :
                  </label>
                  <div className="w-100 col">
                    {data?.first_enquiry_date || "N/A"}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Time to first call :
                  </label>
                  <div className="w-100 col">
                    {data?.time_to_first_call || "N/A"}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Enquiry count :
                  </label>
                  <div className="w-100 col">
                    {data?.enquiry_count || "N/A"}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Lead Source :</label>
                  <div className="w-100 col">{data?.lead_source || "N/A"}</div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Source quality:
                  </label>
                  <div className="w-100 col">
                    {data?.source_quality || "N/A"}
                  </div>
                </div>
              )}

              <hr></hr>
              <h2>
                Customer type & Customer Experience & Customer Interest & Lead
                Details{" "}
              </h2>
              <hr></hr>

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Customer Type:
                  </label>
                  <div className="w-100 col">
                    {data?.customer_type || "N/A"}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Experience Level:
                  </label>
                  <div className="w-100 col">
                    {data?.experience_level || "N/A"}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Occupation:</label>
                  <div className="w-100 col">{data?.occupation || "N/A"}</div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Location type:
                  </label>
                  <div className="w-100 col">
                    {data?.location_type || "N/A"}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Interest type:
                  </label>
                  <div className="w-100 col">
                    {Array.isArray(data?.interest_type)
                      ? data.interest_type.join(", ")
                      : data?.interest_type || "N/A"}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Land available:
                  </label>
                  <div className="w-100 col">
                    {data?.land_available || "N/A"}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Funding type:</label>
                  <div className="w-100 col">{data?.funding_type || "N/A"}</div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Subsidy interest:
                  </label>
                  <div className="w-100 col">
                    {data?.subsidy_interest || "N/A"}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Timeline:</label>
                  <div className="w-100 col">{data?.timeline || "N/A"}</div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Decision Stage:
                  </label>
                  <div className="w-100 col">
                    {data?.decision_stage || "N/A"}
                  </div>
                </div>
              )}

              {data?.lead_strength && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Lead strength:
                  </label>
                  <div className="w-100 col">
                    {data?.lead_strength || "N/A"}
                  </div>
                </div>
              )}

              {data?.lead_strength && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Lead strength:
                  </label>
                  <div className="w-100 col">
                    {data?.lead_strength || "N/A"}
                  </div>
                </div>
              )}

              {data?.engagement_level && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Engagement level
                  </label>
                  <div className="w-100 col">
                    {data?.engagement_level || "N/A"}
                  </div>
                </div>
              )}

              {data?.customer_stage && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Customer stage
                  </label>
                  <div className="w-100 col">
                    {Array.isArray(data?.customer_stage)
                      ? data.customer_stage.join(", ")
                      : data?.customer_stage || "N/A"}
                  </div>
                </div>
              )}

              {data?.marketing_bucket && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Customer stage
                  </label>
                  <div className="w-100 col">
                    {data?.marketing_bucket || "N/A"}
                  </div>
                </div>
              )}

              <hr></hr>
              <h2>Webinar & Practical Tranning & Site Inspection Purchase</h2>
              <hr></hr>
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Webinar purchase date
                  </label>
                  <div className="w-100 col">
                    {data?.webinar_purchase_date || "N/A"}
                  </div>
                </div>
              )}

              {data?.practical_training_purchase_date && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Practical training purchase date
                  </label>
                  <div className="w-100 col">
                    {data?.practical_training_purchase_date || "N/A"}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Site inspection purchase date
                  </label>
                  <div className="w-100 col">
                    {data?.site_inspection_purchase_date || "N/A"}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Site Inspection Stage
                  </label>
                  <div className="w-100 col">
                    {data?.site_inspection_stage
                      ? "Complate"
                      : "Pending" || "N/A"}
                  </div>
                </div>
              )}

              {/* {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Site inspection date
                  </label>
                  <div className="w-100 col">{data?.site_inspection_date || "N/A"}</div>
                </div>
              )} */}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Site inspection created dates
                  </label>
                  <div className="w-100 col">
                    {" "}
                    {Array.isArray(data?.site_inspection_date)
                      ? data.site_inspection_date.join(", ")
                      : data?.site_inspection_date || "N/A"}
                  </div>
                </div>
              )}

              <hr></hr>
              <h2>Hydrophonic Masterclass</h2>
              <hr></hr>
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Masterclass purchase_date
                  </label>
                  <div className="w-100 col">
                    {data?.masterclass_purchase_date || "N/A"}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Masterclass completion percentage
                  </label>
                  <div className="w-100 col">
                    {data?.masterclass_completion_percentage || "N/A"}
                  </div>
                </div>
              )}

              {data?.masterclass_course_name && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Masterclass Course Name
                  </label>
                  <div className="w-100 col">
                    {data?.masterclass_course_name || "N/A"}
                  </div>
                </div>
              )}

              <hr></hr>
              <h2>Quotation Details</h2>
              <hr></hr>

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Quotation created dates
                  </label>
                  <div className="w-100 col">
                    {Array.isArray(data?.quotation_created_date)
                      ? data.quotation_created_date.join(", ")
                      : data?.quotation_created_date || "N/A"}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    All quotations IDs
                  </label>
                  <div className="w-100 col">
                    {Array.isArray(data?.all_quotations)
                      ? data.all_quotations.join(", ")
                      : data?.all_quotations || "N/A"}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Quotation types
                  </label>
                  <div className="w-100 col">
                    {Array.isArray(data?.quotation_types)
                      ? data.quotation_types.join(", ")
                      : data?.quotation_types || "N/A"}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Quotation area
                  </label>
                  <div className="w-100 col">
                    {Array.isArray(data?.quotation_area)
                      ? data.quotation_area.join(", ")
                      : data?.quotation_area || "N/A"}
                    &nbsp;sqm
                  </div>
                </div>
              )}
              <hr></hr>
              <h1>Farm construction advance date</h1>
              <hr></hr>

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Farm construction advance date
                  </label>
                  <div className="w-100 col">
                    {data?.farm_construction_advance_date || "N/A"}
                  </div>
                </div>
              )}

              <hr></hr>
              <h2>Lead Details</h2>
              <hr></hr>

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Lead stage status
                  </label>
                  <div className="w-100 col">
                    {data?.lead_stage_status || "N/A"}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Lead qualifier name
                  </label>
                  <div className="w-100 col">
                    {data?.lead_qualifier_name || "N/A"}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Lead executive custodian
                  </label>
                  <div className="w-100 col">
                    {data?.lead_custodian || "N/A"}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Last executive name
                  </label>
                  <div className="w-100 col">
                    {data?.last_executive_name || "N/A"}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Lead closer added date
                  </label>
                  <div className="w-100 col">
                    {data?.lead_closer_added_date || "N/A"}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Lead conversion duration
                  </label>
                  <div className="w-100 col">
                    {data?.lead_conversion_duration || "N/A"}&nbsp;days
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Last closer name
                  </label>
                  <div className="w-100 col">
                    {data?.last_closer_name || "N/A"}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Last closer custodian
                  </label>
                  <div className="w-100 col">
                    {data?.lead_closer_custodian || "N/A"}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Days lead with executive
                  </label>
                  <div className="w-100 col">
                    {data?.days_lead_with_executive || "N/A"}&nbsp;days
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Days lead with closer
                  </label>
                  <div className="w-100 col">
                    {data?.days_lead_with_closer || "N/A"}&nbsp;days
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Closer Lead Paid Status
                  </label>
                  <div className="w-100 col">{data?.closerStatus || "N/A"}</div>
                </div>
              )}

              <hr></hr>
              <h2>Lead Stage</h2>
              <hr></hr>

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Software demo stage
                  </label>
                  <div className="w-100 col">
                    {data?.software_demo_stage
                      ? "Complate"
                      : "Pending" || "N/A"}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Software demo date
                  </label>
                  <div className="w-100 col">
                    {data?.software_demo_date || "N/A"}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Site Inspection Stage
                  </label>
                  <div className="w-100 col">
                    {data?.site_inspection_stage
                      ? "Complate"
                      : "Pending" || "N/A"}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Site inspection date
                  </label>
                  <div className="w-100 col">{data?.site_inspection_date || "N/A"}</div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Site inspection created date
                  </label>
                  <div className="w-100 col">
                    {" "}
                    {Array.isArray(data?.site_inspection_date)
                      ? data.site_inspection_date.join(", ")
                      : data?.site_inspection_date || "N/A"}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    DPR explanation date
                  </label>
                  <div className="w-100 col">
                    {" "}
                    <div className="w-100 col">
                      {data?.dpr_explanation_date}
                    </div>
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    DPR explanation stage
                  </label>
                  <div className="w-100 col">
                    {" "}
                    <div className="w-100 col">
                      {data?.dpr_explanation_stage == "Yes"
                        ? "Complate"
                        : "Pending"}
                    </div>
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Work order date
                  </label>
                  <div className="w-100 col">
                    {" "}
                    <div className="w-100 col">
                      {data?.work_order_stage_date}
                    </div>
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Work order stage
                  </label>
                  <div className="w-100 col">
                    {" "}
                    <div className="w-100 col">
                      {data?.work_order_stage ? "Complate" : "Pending"}
                    </div>
                  </div>
                </div>
              )}

              <hr></hr>
              <h2>Followup History {`(${data?.followup_history?.length})`} </h2>
              <hr></hr>
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Total Followup Count
                  </label>
                  <div className="w-100 col">
                    {" "}
                    <div className="w-100 col">
                      {data?.followup_history?.length}
                    </div>
                  </div>
                </div>
              )}

              <div className="table-responsive">
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>Lead ID</th>
                      <th>Folloup Msg</th>
                      <th>Followup Created</th>
                      <th>Followup Date</th>
                      <th>Followup Status</th>
                      <th>Followup Call Taken</th>
                      <th>Followup Call Taken Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.followup_history?.map((item, index) => (
                      <tr key={index}>
                        <td>{item.lead_id}</td>
                        <td>{item.followUp}</td>
                        <td>{item.createdAt}</td>
                        <td>{item.followUpDate}</td>
                        <td>{item.followUpStatus}</td>
                        <td>{item.followupTaken ? "Yes" : "No"}</td>
                        <td>{item.followupTakenDate || "N/A"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <hr></hr>
              <h2>Call History {`(${data?.lead_call_history?.length})`} </h2>
              <hr></hr>
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Time to first call
                  </label>

                  <div className="w-100 col">
                    {(() => {
                      const raw = data?.time_to_first_call;

                      if (!raw) return "-";

                      try {
                        const [durationPart, datePart] = raw.split("/");

                        const duration = durationPart?.split("Duration-")[1];
                        const dateStr = datePart?.split("Date-Time-")[1];

                        const formattedDate = new Date(dateStr).toLocaleString(
                          "en-IN",
                          {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                            hour: "numeric",
                            minute: "2-digit",
                          }
                        );

                        return `${duration} min (${formattedDate})`;
                      } catch (err) {
                        return raw; // fallback
                      }
                    })()}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Total Call Count
                  </label>
                  <div className="w-100 col">
                    {" "}
                    <div className="w-100 col">{data?.total_calls_between}</div>
                  </div>
                </div>
              )}

              <div className="table-responsive">
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>Sr</th>
                      <th>Kryzen Contact Number</th>
                      <th>Duration</th>
                      <th>Answered</th>
                      <th>Caller Name</th>
                      <th>Customer Contact</th>
                      <th>Customer Name</th>
                      <th>Date / Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.lead_call_history?.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item?.number}</td>
                        <td>{item?.duration || "N/A"}</td>
                        <td>{item?.answered ? "Yes" : "No" || "N/A"}</td>
                        <td>{item?.userName || "N/A"}</td>
                        <td>{item?.userPhone || "N/A"}</td>
                        <td>{item?.phonebookName || "N/A"}</td>
                        <td>{item?.startTime || "N/A"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default ViewLeadMaster;
